import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _slot;

import { MediaTextDisplay } from "./media-text-display.js";
import { getBooleanAttr, getNumericAttr, getOrInsertCSSRule, setBooleanAttr, setNumericAttr } from "./utils/element-utils.js";
import { globalThis } from "./utils/server-safe-globals.js";
import { formatAsTimePhrase, formatTime } from "./utils/time.js";
import { MediaUIAttributes } from "./constants.js";
import { nouns } from "./labels/labels.js";
var Attributes = {
  REMAINING: "remaining",
  SHOW_DURATION: "showduration",
  NO_TOGGLE: "notoggle"
};
var CombinedAttributes = [].concat(_toConsumableArray(Object.values(Attributes)), [MediaUIAttributes.MEDIA_CURRENT_TIME, MediaUIAttributes.MEDIA_DURATION, MediaUIAttributes.MEDIA_SEEKABLE]);
var ButtonPressedKeys = ["Enter", " "];
var DEFAULT_TIMES_SEP = "&nbsp;/&nbsp;";

var formatTimesLabel = function formatTimesLabel(el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timesSep = _ref.timesSep,
      timesSep = _ref$timesSep === void 0 ? DEFAULT_TIMES_SEP : _ref$timesSep;

  var _a, _b, _c, _d;

  var showRemaining = el.hasAttribute(Attributes.REMAINING);
  var showDuration = el.hasAttribute(Attributes.SHOW_DURATION);
  var currentTime = (_a = el.mediaCurrentTime) != null ? _a : 0;

  var _ref2 = (_b = el.mediaSeekable) != null ? _b : [],
      _ref3 = _slicedToArray(_ref2, 2),
      seekableEnd = _ref3[1];

  var endTime = (_d = (_c = el.mediaDuration) != null ? _c : seekableEnd) != null ? _d : 0;
  var timeLabel = showRemaining ? formatTime(0 - (endTime - currentTime)) : formatTime(currentTime);
  if (!showDuration) return timeLabel;
  return "".concat(timeLabel).concat(timesSep).concat(formatTime(endTime));
};

var DEFAULT_MISSING_TIME_PHRASE = "video not loaded, unknown time.";

var updateAriaValueText = function updateAriaValueText(el) {
  var _a;

  var currentTime = el.mediaCurrentTime;

  var _ref4 = (_a = el.mediaSeekable) != null ? _a : [],
      _ref5 = _slicedToArray(_ref4, 2),
      seekableEnd = _ref5[1];

  var endTime = el.mediaDuration || seekableEnd;

  if (currentTime == null || endTime == null) {
    el.setAttribute("aria-valuetext", DEFAULT_MISSING_TIME_PHRASE);
    return;
  }

  var showRemaining = el.hasAttribute(Attributes.REMAINING);
  var showDuration = el.hasAttribute(Attributes.SHOW_DURATION);
  var currentTimePhrase = showRemaining ? formatAsTimePhrase(0 - (endTime - currentTime)) : formatAsTimePhrase(currentTime);

  if (!showDuration) {
    el.setAttribute("aria-valuetext", currentTimePhrase);
    return;
  }

  var totalTimePhrase = formatAsTimePhrase(endTime);
  var fullPhrase = "".concat(currentTimePhrase, " of ").concat(totalTimePhrase);
  el.setAttribute("aria-valuetext", fullPhrase);
};

var MediaTimeDisplay = /*#__PURE__*/function (_MediaTextDisplay) {
  _inherits(MediaTimeDisplay, _MediaTextDisplay);

  var _super = _createSuper(MediaTimeDisplay);

  function MediaTimeDisplay() {
    var _this;

    _classCallCheck(this, MediaTimeDisplay);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _slot, void 0);

    __privateSet(_assertThisInitialized(_this), _slot, _this.shadowRoot.querySelector("slot"));

    __privateGet(_assertThisInitialized(_this), _slot).innerHTML = "".concat(formatTimesLabel(_assertThisInitialized(_this)));

    var _getOrInsertCSSRule = getOrInsertCSSRule(_this.shadowRoot, ":host(:hover:not([notoggle]))"),
        style = _getOrInsertCSSRule.style;

    style.setProperty("cursor", "pointer");
    style.setProperty("background", "var(--media-control-hover-background, rgba(50 50 70 / .7))");
    return _this;
  }

  _createClass(MediaTimeDisplay, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      if (!this.hasAttribute("disabled")) {
        this.enable();
      }

      this.setAttribute("role", "progressbar");
      this.setAttribute("aria-label", nouns.PLAYBACK_TIME());

      var keyUpHandler = function keyUpHandler(evt) {
        var key = evt.key;

        if (!ButtonPressedKeys.includes(key)) {
          _this2.removeEventListener("keyup", keyUpHandler);

          return;
        }

        _this2.toggleTimeDisplay();
      };

      this.addEventListener("keydown", function (evt) {
        var metaKey = evt.metaKey,
            altKey = evt.altKey,
            key = evt.key;

        if (metaKey || altKey || !ButtonPressedKeys.includes(key)) {
          _this2.removeEventListener("keyup", keyUpHandler);

          return;
        }

        _this2.addEventListener("keyup", keyUpHandler);
      });
      this.addEventListener("click", this.toggleTimeDisplay);

      _get(_getPrototypeOf(MediaTimeDisplay.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "toggleTimeDisplay",
    value: function toggleTimeDisplay() {
      if (this.noToggle) {
        return;
      }

      if (this.hasAttribute("remaining")) {
        this.removeAttribute("remaining");
      } else {
        this.setAttribute("remaining", "");
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.disable();

      _get(_getPrototypeOf(MediaTimeDisplay.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (CombinedAttributes.includes(attrName)) {
        this.update();
      } else if (attrName === "disabled" && newValue !== oldValue) {
        if (newValue == null) {
          this.enable();
        } else {
          this.disable();
        }
      }

      _get(_getPrototypeOf(MediaTimeDisplay.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);
    }
  }, {
    key: "enable",
    value: function enable() {
      this.tabIndex = 0;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.tabIndex = -1;
    }
  }, {
    key: "remaining",
    get: function get() {
      return getBooleanAttr(this, Attributes.REMAINING);
    },
    set: function set(show) {
      setBooleanAttr(this, Attributes.REMAINING, show);
    }
  }, {
    key: "showDuration",
    get: function get() {
      return getBooleanAttr(this, Attributes.SHOW_DURATION);
    },
    set: function set(show) {
      setBooleanAttr(this, Attributes.SHOW_DURATION, show);
    }
  }, {
    key: "noToggle",
    get: function get() {
      return getBooleanAttr(this, Attributes.NO_TOGGLE);
    },
    set: function set(notoggle) {
      setBooleanAttr(this, Attributes.NO_TOGGLE, notoggle);
    }
  }, {
    key: "mediaDuration",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_DURATION);
    },
    set: function set(time) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_DURATION, time);
    }
  }, {
    key: "mediaCurrentTime",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_CURRENT_TIME);
    },
    set: function set(time) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_CURRENT_TIME, time);
    }
  }, {
    key: "mediaSeekable",
    get: function get() {
      var seekable = this.getAttribute(MediaUIAttributes.MEDIA_SEEKABLE);
      if (!seekable) return void 0;
      return seekable.split(":").map(function (time) {
        return +time;
      });
    },
    set: function set(range) {
      if (range == null) {
        this.removeAttribute(MediaUIAttributes.MEDIA_SEEKABLE);
        return;
      }

      this.setAttribute(MediaUIAttributes.MEDIA_SEEKABLE, range.join(":"));
    }
  }, {
    key: "update",
    value: function update() {
      var timesLabel = formatTimesLabel(this);
      updateAriaValueText(this);

      if (timesLabel !== __privateGet(this, _slot).innerHTML) {
        __privateGet(this, _slot).innerHTML = timesLabel;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaTimeDisplay), "observedAttributes", this)), _toConsumableArray(CombinedAttributes), ["disabled"]);
    }
  }]);

  return MediaTimeDisplay;
}(MediaTextDisplay);

_slot = new WeakMap();

if (!globalThis.customElements.get("media-time-display")) {
  globalThis.customElements.define("media-time-display", MediaTimeDisplay);
}

var media_time_display_default = MediaTimeDisplay;
export { Attributes, media_time_display_default as default };